import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

// Eager metadata registration; the render component (MapWidget) code-splits
// into its own tpl-map-widget chunk, loaded on demand when the widget renders.
registerCardTemplate({
    id: 'map-widget',
    name: 'Map Widget',
    description: 'A map with markers on it. Either use a global satellite map or specify your own tile server and data source to pull and show coordinates on the map. Configure cusotm content to show when clicking on a marker.',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-map-widget" */ "./MapTemplate")),
    icon: generateIconProp('mapMarked'),
    canDragDropFields: true,
    complexity: 'hard',

});
